import React, { useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import DashboardCards from "../components/DashboardCards/DashboardCards";
// removed unused icon imports
import "../styles/Dashboard.css";
import LineChartComponent from "../components/LineGraphComponent/LineChartComponent";
import TableComponent from "../components/TableComponent/TableComponent";
// FarmerMap removed (unused)
import TitleComponent from "../components/TitleComponent/TitleComponent";
import DoughnutChartComponent from "../components/DoughnutChartComponent/DoughnutChartComponent";
import { useSelector, useDispatch } from "react-redux";
import { ICONS } from "../constants/constants";
import { Link } from "react-router-dom";
import { handleGetCompanyData } from "../store/actions/adminActions";
// Removed unused list fetch imports; tenant data provides lists where needed
import { handleGetTenantData, handleGetTenantFarmersData, handleGetTenantSuppliersData, handleGetTenantConsultantsData } from "../store/actions/tenantsActions";
import jsPDF from "jspdf";
import "jspdf-autotable";
// import EditFarmerModal from "../components/Modals/EditFarmerModal";
import Loader from "../assets/images/loader.gif";

const Consultants = () => {
  const dispatch = useDispatch();

  //const { role } = getAdminIdFromToken();
  const { user } = useSelector((state) => state.user);
  const { tenantFarmersData, tenantSuppliersData, tenantConsultantsData, isLoading } = useSelector((state) => state.tenants);
  const adminId = user?.id;
  const companyId = user?.company?.id;
  const role = user?.role;

  // useEffect(() => {
  //   if (adminId) {
  //     dispatch(handleGetAdminData(adminId)); // Pass only adminId
  //   }
  // }, [dispatch, adminId]);

  const tenantId = role === "superadmin" ? user?.tenant?.id : null; // Save superAdminId if role is superadmin

  useEffect(() => {
    if (role === "superadmin" && tenantId) {
      // Fetch tenant data for superadmin
      dispatch(handleGetTenantData(tenantId));
      dispatch(handleGetTenantFarmersData(tenantId));

      dispatch(handleGetTenantSuppliersData(tenantId));
      dispatch(handleGetTenantConsultantsData(tenantId));

    } else if ((role === "admin" || role === "manager") && companyId) {
      // Fetch company data for admin users
      dispatch(handleGetCompanyData(companyId));
    }
  }, [dispatch, adminId, tenantId, role, companyId]);

  // const usersList = tenantData?.data?.tenant?.users;

  const superAdminFarmers = tenantFarmersData?.data?.farmers;
  const superAdminSuppliers = tenantSuppliersData?.data?.suppliers;
  const superAdminConsultants = tenantConsultantsData?.data?.consultants;


  // Fetch the farmer list conditionally based on the role
  const farmersListFromStore = useSelector((state) => state.farmer); // Always call useSelector
  const suppliersListFromStore = useSelector((state) => state.supplier);
  const consultantsListFromStore = useSelector((state) => state.consultant);

  // Access the adminData from the Redux store
  const { adminList } = useSelector((state) => state.admin);

  // Safely log the adminData and adminUsers
  // useEffect(() => {
  //   if (adminData) {
  //     if (adminData?.adminUsers) {
  //     } else {
  //     }
  //   } else {
  //   }
  // }, [adminData]);

  // Filter the admin users based on role "farmer"
  // Support both admin/getadmindata and company/:id response shapes
  const companySource = adminList?.admin || adminList?.data?.company;
  const companyName = companySource?.name || companySource?.company?.name;
  // const suppliersList = adminData?.admin?.adminUsers?.filter(user => user.role === "supplier");
  const consultantList =
    (role === "admin" || role === "manager")
      ? (companySource?.adminUsers ||
          companySource?.suppliers?.filter((u) => u.role === "consultant") ||
          adminList?.admin?.adminUsers?.filter((u) => u.role === "consultant") ||
          consultantsListFromStore?.consultantList?.data?.consultants ||
          [])
      : superAdminConsultants;

  // Convert budgetPerAcre to a number
  const budgetPerAcre =
    parseFloat(adminList?.shiriahBudget?.[0]?.budgetPerAcre) || 0;

  let totalBudget = 0; // Initialize total budget separately
  // const consultantList = adminData?.admin?.adminUsers?.filter(user => user.role === "consultant");

  // const { consultantList } = useSelector((state) => state.consultant);

  // const { farmerList } = useSelector((state) => state.farmer);
  // const { suppliersList } = useSelector((state) => state.supplier);

  // Consultant list is provided via company or tenant responses; no separate fetch here

  // Define data for BarChartComponent
  const doughnutData = {
    labels: ["Category 1", "Category 2", "Category 3"],
    datasets: [
      {
        data: [300, 500, 200], // Data for each segment
      },
    ],
  };

  const total = 1000;

  // Define data for LineChartComponent
  const lineChartData = {
    labels: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep"],
    datasets: [
      {
        label: "Budget",
        data: [30, 45, 28, 50, 42, 56, 40, 55, 30],
        borderColor: "rgba(75, 192, 192, 1)",
        backgroundColor: "rgba(75, 192, 192, 0.2)",
        tension: 0.4,
      },
      {
        label: "Revenue",
        data: [20, 35, 25, 45, 35, 50, 38, 48, 25],
        borderColor: "rgba(255, 159, 64, 1)",
        backgroundColor: "rgba(255, 159, 64, 0.2)",
        tension: 0.4,
      },
      {
        label: "Farmed",
        data: [25, 40, 22, 48, 38, 52, 33, 50, 28],
        borderColor: "rgba(153, 102, 255, 1)",
        backgroundColor: "rgba(153, 102, 255, 0.2)",
        tension: 0.4,
      },
    ],
  };

  // const [showEditModal, setShowEditModal] = useState(false); // State to control edit modal visibility
  // // Handle edit icon click to show edit modal
  // const handleEditClick = () => {
  //   setShowEditModal(true); // Show the edit modal
  // };
  // PDF Downloader
  const handleDownloadPDF = (consultant) => {
    const doc = new jsPDF();

    // Title
    doc.setFontSize(18);
    doc.text("Consultant Details", 14, 20);

    // Farmer Data
    // const farmArea = supplier.farmDetails?.reduce(
    //   (sum, farm) => sum + (parseFloat(farm.farm_area) || 0),
    //   0
    // );

    const tableColumn = ["Field", "Details"];
    const tableRows = [
      ["ID", consultant?.id],
      ["Name", consultant?.name],
      // ["Email", consultant?.email],
      ...(role !== "manager" ?  ["Phone", consultant?.mobile_number || "N/A"]  : []),
      ...(role !== "manager" ?  ["CNIC", consultant?.cnic || "N/A"]  : []),
      // ["Farm Area", farmArea ? `${farmArea} acres` : "N/A"],
      ["Status", consultant?.account_status || "Pending"],
    ];

    // AutoTable for formatting
    doc.autoTable({
      startY: 30,
      head: [tableColumn],
      body: tableRows,
      theme: "grid",
      headStyles: {
        fillColor: [0, 128, 0], // Green header background
        textColor: [255, 255, 255], // White text color
        fontStyle: "bold",
      },
    });

    // Save PDF
    doc.save(`Consultant_${consultant?.id}.pdf`);
  };
  const tableTitle = "Consultants";
  const searchplaceholder = "Search by Consultant’s Name";
  const columns = ["Name", "Company", role !== "manager" ? "Mobile" : "", role !== "manager" ? "CNIC" : "", "Status", "Actions"];
  const visibleConsultantList =
    role === "manager"
      ? ( (companySource?.adminUsers || companySource?.suppliers || adminList?.admin?.adminUsers || []).filter((u) => u.role === "consultant" && u.account_status === "Approved") )
      : role === "admin"
    ? (companySource?.adminUsers || companySource?.suppliers || adminList?.admin?.adminUsers || [])
        .filter((u) => u.role === "consultant") // admin condition
        : consultantList;

  const data = visibleConsultantList?.map((consultant) => ({
    Name: consultant?.name,
    Company:
      consultant?.company?.name || companyName || consultant?.companies?.[0]?.name || "N/A",
    ...(role !== "manager" ? { Mobile: consultant?.mobile_number || "N/A" } : {}), // Replace 'N/A' with default if 'mobile' is not available
    ...(role !== "manager" ? { CNIC: consultant?.cnic } : {}),
    Status: consultant?.account_status || "N/A",
    Actions:
      role === "manager" ? (
        <>
          <Link to={`/consultant/${consultant.id}`} state={{ consultant }} rel="noopener noreferrer">
            <img src={ICONS.viewIcon} alt="View" className="tick-icon" />
          </Link>
          <img src={ICONS.downloadIcon} alt="Download" className="cross-icon" style={{ opacity: 0.5, pointerEvents: "none" }} />
        </>
      ) : consultant?.account_status === "Approved" ? (
        <>
          <Link to={`/consultant/${consultant.id}`} state={{ consultant }} rel="noopener noreferrer">
            <img src={ICONS.viewIcon} alt="View" className="tick-icon" />
          </Link>
          <img src={ICONS.downloadIcon} alt="Download" className="cross-icon" onClick={() => handleDownloadPDF(consultant)} />
        </>
      ) : (
        <>
          <Link to={`/consultant/${consultant.id}`} state={{ consultant }} rel="noopener noreferrer">
            <img src={ICONS.viewIcon} alt="View" className="tick-icon" />
          </Link>
        </>
      ),
  }));
  const handleEdit = (row) => {
    // Implement edit logic here (open a modal, navigate to edit page, etc.)
  };

  const handleDelete = (row) => {
    // Implement delete logic here (e.g., show a confirmation dialog, remove from state, etc.)
  };

  const handleDownload = (row) => {
    // Implement download logic here (e.g., download file or export row data)
  };

  // Pass dynamically if these features should be shown
  const showSearchBar = true; // Change to false to hide search bar
  const showFilter = false; // Change to false to hide filter
  const showTabs = true; // Change to false to hide tabs (Approved/Not Approved)

  const getCountByRole = (userRole) => {
    const users = companySource?.adminUsers || companySource?.suppliers || adminList?.admin?.adminUsers || [];
    return users.filter((user) => user.role === userRole).length || 0;
  };

 

   const getCounts = () => {
//  console.log(`Getting counts for role: ${role}`);
  const { farmers, suppliers, consultants } = getUsersByRole(role);
// console.log(`Counts - Farmers: ${farmers.length}, Suppliers: ${suppliers.length}, Consultants: ${consultants.length}`);
  return {
    farmers: farmers.length,
    suppliers: suppliers.length,
    consultants: consultants.length,
  };
};


  const getUsersByRole = (role) => {
  if (role === "superadmin") {
    return {
      farmers: superAdminFarmers || [],
      suppliers: superAdminSuppliers || [],
      consultants: superAdminConsultants || [],
    };
  }
  if (role === "admin" || role === "manager") {
    const users = companySource?.adminUsers || companySource?.suppliers || adminList?.admin?.adminUsers || [];
    return {
      farmers: users.filter((u) => u.role === "farmer") || [],
      suppliers: users.filter((u) => u.role === "supplier") || [],
      consultants:
        users.filter((u) => u.role === "consultant") ||
        consultantsListFromStore?.consultantList?.data?.consultants ||
        [],
    };
  }
  return {
    farmers: farmersListFromStore?.farmersList?.data?.farmers || [],
    suppliers: suppliersListFromStore?.suppliersList?.data?.suppliers || [],
    consultants:
      consultantsListFromStore?.consultantList?.data?.consultants || [],
  };
};

const getCountByApprovalStatus = (userRole, status) => {
  console.log(`Getting count for role: ${userRole} with status: ${status}`);
  const { farmers, suppliers, consultants } = getUsersByRole(role); // role = logged-in user

  const roleMap = {
    farmer: farmers,
    supplier: suppliers,
    consultant: consultants,
  };

  const list = roleMap[userRole] || [];

  return list.filter((user) => user.account_status === status).length;
};

  // const getCountByRole = (role) => {
  //   return adminData?.admin?.adminUsers?.filter((user) => user.role === role).length;
  // };

  const cardData = [
    ...(user?.role !== "manager"
      ? [
        {
          title: "Shariah Budget",
          value: `${totalBudget} PKR`,
          colorKey: "budget",
          imageKey: "budgetIcon",
        },
        ]
      : []),
   
    {
      title: "No of Consultants",
      value: `${
    role === "admin"
      ? getUsersByRole(role).consultants.length
      : getCounts().consultants
  }`,
      colorKey: "farmer",
      imageKey: "consultantIcon",
    },
    {
      title: "Approved Consultants",
      value: `${
    role === "admin"
      ? getCountByApprovalStatus("consultant", "Approved")
      : getCountByApprovalStatus("consultant", "Approved")
  }`,
      //value: totalSuppliers,
      colorKey: "supplier",
      imageKey: "consultantIcon",
    },
    {
      title: "Not Approved Consultants",
      value: `${
    role === "admin"
      ? getCountByApprovalStatus("consultant", "NotApproved")
      : getCountByApprovalStatus("consultant", "NotApproved")
  }`,
      //value:  consultantList?.data?.consultants?.length || "0",
      colorKey: "consultant",
      imageKey: "consultantIcon",
    },
  ];
  if (isLoading) {
    return (
      <div className="loaderOverlay">
        <img src={Loader} alt="Loader" />
      </div>
    );
  }

  return (
    <Container>
      <Row>
        <Col lg={12} className="component-container mb-2">
          <TitleComponent title="Dashboard" />
          
          <DashboardCards cardData={cardData} />
        </Col>
      </Row>
      {user?.role !== "manager" && (
        <Row className="d-flex justify-content-between two-columns">
          <Col md={5} className="component-container mb-2">
            <TitleComponent title="Productions Details" />

            <DoughnutChartComponent data={doughnutData} total={total} />
          </Col>
          <Col md={5} className="component-container mb-2">
            <TitleComponent title="Finance" />

            <LineChartComponent data={lineChartData} />
          </Col>
        </Row>
      )}
      <Row>
        <Col lg={12} className="component-container mb-2">
          <TableComponent
            columns={columns}
            data={data}
            title={tableTitle}
            searchplaceholder={searchplaceholder}
            showSearchBar={showSearchBar}
            showFilter={showFilter}
            showTabs={showTabs && user?.role !== "manager"}
            onEdit={handleEdit}
            onDelete={handleDelete}
            onDownload={handleDownload}
          />
        </Col>
      </Row>
      {/* <EditFarmerModal
        show={showEditModal}
        handleClose={() => setShowEditModal(false)}
        user={user}
        userType={user?.userdatarole}
      /> */}
    </Container>
  );
};

export default Consultants;
